Ext.define('SA.view.combolocation.EditCombinationLocation', {
    alias: 'widget.edit-combination-location',
    extend: 'SA.view.combolocation.CombinationLocationWindow',

    title: 'Edit Combination Location',

    initComponent() {
        var combo = this.combo;

        this.callParent();

        this.nameField.setValue(combo.name);
        this.locationsList.setLocations(combo.locationSeries);
    },

    save() {
        var combo = this.combo;

        this.setLoading('Saving…');

        combo.name = this.getNameFieldValue();
        combo.locationSeries = this.locationsList.getLocations();

        SA.data.CustomLocations.updateCombo(combo, combo => {
            this.destroy();

            Ext.callback(this.callback, this.scope, [combo]);
        });
    }
});
